import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=37d51e8b&scoped=true&"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=37d51e8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d51e8b",
  null
  
)

export default component.exports